/** ************************************************************************************
* GEOLOCATION
*/

var disableSearchStop = false;
var maps = [];
var markerCluster = null;
var stopsRequested = false;
var previousMarkers = [];

var googleAPIKey = "";

$.post(Routing.generate("request_google_api_key"), function (data) {
    googleAPIKey = data;
});

/* ************************************************************************************
 * HTML5 GEOLOCATION
 */

var geolocationOptions = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
};

$("#use-my-position").change( function() {

    if(googleAPIKey == "") {
        $(this).prop("checked", false);
        alert("Non è stato possibile determinare la posizione. Controlla che il gps sia abilitato e ricarica la pagina.")
    } else {
        if($(this).prop("checked") == true) {

            // loader
            $("#input-start-from").prop("readonly", true);

            // CALL
            navigator.geolocation.getCurrentPosition(
                // success
                function (pos) {

                    var crd = pos.coords;

//                     $.post("https://maps.googleapis.com/maps/api/geocode/json?address="+crd.latitude + "," + crd.longitude+"&key="+CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(googleAPIKey)), function (data) {
// console.log(data);
//                         $("#input-start-from-hidden").val(crd.latitude + "," + crd.longitude);
//                         if (typeof data.results[0].formatted_address != 'undefined' && data.results[0].formatted_address) {
//                             $("#input-start-from").val(data.results[0].formatted_address)
//                             $("#input-start-from").prop("readonly", false);
//                         }
//                     });
                    $("#input-start-from-hidden").val(crd.latitude + "," + crd.longitude);
                    if (locale == 'it') {
                        $("#input-start-from").val('Posizione attuale');
                    } else {
                        $("#input-start-from").val('My position')
                    }
                    $("#input-start-from").prop("readonly", false);
                },
                // error
                function (err) {
                    $("#input-start-from").prop("readonly", false);
                    alert("Non è stato possibile determinare la posizione. Controlla che il gps sia abilitato e ricarica la pagina.");
                    //console.log('ERROR(' + err.code + '): ' + err.message);
                },
                // options
                geolocationOptions
            );
        }
    }
});

//$(document).on("click", ".copy-in-input", function (event) {
//
//    event.stopImmediatePropagation;
//
//    $("#"+$(this).attr("data-refer-input")).val($(this).attr("data-description"));
//    $("#"+$(this).attr("data-refer-input")+"-hidden").val($(this).attr("data-coords"));
//});

/**
 * Switch tra i 2 campi input partenza e arrivo
 */
function switchValueFromTo(id1, id2) {
    var startFrom = $('#'+id1).val();
    var goTo = $('#'+id2).val();
    var startFromHidden = $('#'+id1+"-hidden").val();
    var goToHidden = $('#'+id2+"-hidden").val();

    $('#'+id1).val(goTo);
    $('#'+id2).val(startFrom);
    $('#'+id1+"-hidden").val(goToHidden);
    $('#'+id2+"-hidden").val(startFromHidden);
}

/**
 * translate coords engine
 */

function geolocateCoords(array, index) {

    if(array[index]) {

        //var parameters = new Array();
        //parameters.push(["address", $("#"+array[index]).attr("data-coords")]);

        var coords = $("#"+array[index]).attr("data-coords").split(",");

        //var url = Routing.generate("google_api_router", {
        //    api_url: "https://maps.googleapis.com/maps/api/geocode/json",
        //    parameters: JSON.stringify(parameters)
        //});
        //$.post(url, function (data) {
        //
        //    data = JSON.parse(data);
        //    $("#"+array[index]).html(data.results[0].formatted_address);
        //
        //    geolocateCoords(array, index + 1);
        //});
        var url = Routing.generate("decode_place", {
            lat: coords[0],
            lon: coords[1]
        });
        $.post(url, function (data) {

            //data = JSON.parse(data);
            //$("#"+array[index]).html(data.results[0].formatted_address);
            $("#"+array[index]).html(data);

            geolocateCoords(array, index + 1);
        });
    }
}

function checkGeolocateCoords() {

    var toGeolocateArray = new Array();
    var index = 0;

    var count = $(".geolocate-coords").length;
    $.each($(".geolocate-coords"), function() {

        var id = "geolocable-"+uniqid()+index;

        //console.log("generate "+id);

        $(this).attr("id", id);
        toGeolocateArray[index] = id;

        if (!--count) {
            //console.log(toGeolocateArray);
            geolocateCoords(toGeolocateArray, 0);
        }
        index = index + 1;
    });
}

checkGeolocateCoords();

/**
 * MAPPA
 */

var polylinesDrawed = new Array();

/**
 * spezza i waypoints in array da 8 per annullare il limite delle API
 */
function drawWaypointPolyline(map, points, color, drawPoints) {

    /* tiene traccia delle polyline disegnate */

    if(polylinesDrawed.length > 0) {
        polylinesDrawed[polylinesDrawed.length] = new Array();
    } else {
        polylinesDrawed[0] = new Array();
    }
    polylinesDrawed[polylinesDrawed.length - 1] = new Array();

    var waypoints = new Array();
    var waypointsDetails = new Array();
    //var departureTime = points[0].time;
    for (var i = 0; i < points.length; i ++) {

        waypoints.push({
            location: points[i].coords.lat()+","+points[i].coords.lng(),
            stopover: true
        });
        waypointsDetails.push({
            location: points[i].coords.lat()+","+points[i].coords.lng(),
            stopover: true,
            stopCode: (typeof points[i].stopCode != "undefined" ? points[i].stopCode : ""),
            stopName: (typeof points[i].stopName != "undefined" ? points[i].stopName : ""),
            stopDesc: (typeof points[i].stopDesc != "undefined" ? points[i].stopDesc : ""),
            stopLat: parseFloat((typeof points[i].stopLat != "undefined" ? points[i].stopLat : 0)),
            stopLon: parseFloat((typeof points[i].stopLon != "undefined" ? points[i].stopLon : 0))
        });

        if(i > 0 && i % 7 == 0) {
            drawWaypointPolylinePart(waypoints[0].location, waypoints[waypoints.length - 1].location, waypoints, map, color, drawPoints, waypointsDetails);
            var waypoints = new Array();
            var waypointsDetails = new Array();
            // reinserisce il primo per non creare spazi nella polyline
            waypoints.push({
                location: points[i].coords.lat()+","+points[i].coords.lng(),
                stopover: false
            });
            waypointsDetails.push({
                location: points[i].coords.lat()+","+points[i].coords.lng(),
                stopover: true,
                stopCode: (typeof points[i].stopCode != "undefined" ? points[i].stopCode : ""),
                stopName: (typeof points[i].stopName != "undefined" ? points[i].stopName : ""),
                stopDesc: (typeof points[i].stopDesc != "undefined" ? points[i].stopDesc : ""),
                stopLat: parseFloat((typeof points[i].stopLat != "undefined" ? points[i].stopLat : 0)),
                stopLon: parseFloat((typeof points[i].stopLon != "undefined" ? points[i].stopLon : 0))
            });
        }
        if(i > 0 && i % 7 != 0 && points[i] == points[points.length - 1]) {
            drawWaypointPolylinePart(waypoints[0].location, waypoints[waypoints.length - 1].location, waypoints, map, color, drawPoints, waypointsDetails);
        }
    }
}

function drawWaypointPolylinePart(startFrom, goTo, waypoints, map, color, drawPoints, waypointsDetails) {

    //var directionsService = new google.maps.DirectionsService;
    var directionsDisplay = new google.maps.DirectionsRenderer;
    directionsDisplay.setMap(map);

    $.post(Routing.generate("get_paths_from_directions_service"), {
        origin: startFrom,
        destination: goTo,
        waypoints: waypoints
    })
    .then(function(response) {
        polylinesDrawed[polylinesDrawed.length - 1].push(new google.maps.Polyline({
            strokeColor: color,
            strokeOpacity: 1.0,
            strokeWeight: 4,
            map: map,
            path: polyline.decode(response)
        }));
    });




    /* draw polyline */

    //var now = new Date();
    //now = new Date(now.getYear(), now.getMonth(), now.getDay(), "00", "00", "00", "00");
/*
    directionsService.route({
        origin: startFrom,
        destination: goTo,
        waypoints: waypoints,
        travelMode: google.maps.TravelMode.DRIVING
        //travelMode: google.maps.TravelMode.TRANSIT,
        //transitOptions: {
        //    departureTime: new Date(1465374703),
        //    modes: [google.maps.TransitMode.BUS],
        //    routingPreference: google.maps.TransitRoutePreference.FEWER_TRANSFERS
        //}
    }, function(response, status) {

        if (status === google.maps.DirectionsStatus.OK) {

            if(typeof response.routes[0] != "undefined") {
                var route = response.routes[0];
                if(typeof route.overview_path != "undefiend") {
                    polylinesDrawed[polylinesDrawed.length - 1].push(new google.maps.Polyline({
                        strokeColor: color,
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        map: map,
                        path: polyline.decode(polyline_string)
                    }));
                }
            }
        } else {
            //window.alert('ERROR');
        }
    });
*/
}

/**
 * @constructor
 */
function ResetMap(controlDiv, map) {

    // Set CSS for the control border.
    var controlUI = document.createElement('div');
    controlUI.style.backgroundColor = '#00a6e4';
    controlUI.style.border = '10px';
    controlUI.style.borderRadius = '0';
    controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
    controlUI.style.cursor = 'pointer';
    controlUI.style.textAlign = 'center';
    controlUI.title = 'Reset the map to the original content';
    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior.
    var controlText = document.createElement('div');
    controlText.style.color = '#fff';
    controlText.style.fontFamily = '\'Museo Sans 300\',arial,helvetica,sans-serif';
    controlText.style.fontSize = '16px';
    controlText.style.lineHeight = '38px';
    controlText.style.paddingLeft = '15px';
    controlText.style.paddingRight = '15px';
    controlText.innerHTML = 'RESET';
    controlUI.appendChild(controlText);

    // Setup the click event listeners: simply set the map to Chicago.
    controlUI.addEventListener('click', function() {

        resetCurrentMap(map);
    });
}

/**
 * disegna la route sulla mappa in base alle stop sequence
 */

var stopSequenceCallRequestId = null;
var polylinesDrawed = new Array();
var blockStopDeletingForRoutePresence = false;
var resetMapSetted = false;
function drawRoute(map, routeId, routeColor, date, routeShortName, drawMarkers, drawStartAndEnd) {

    $("#map-overlay-loader").show();

    if(routeColor == "") {
        routeColor = "00abe3";
    }

    stopSequenceCallRequestId = uniqid();
    $.get(Routing.generate("get_route_stop_sequence_waypoints", {
        "routeId": routeId,
        "date": date,
        "stopSequenceCallRequestId": stopSequenceCallRequestId,
        "_": $.now()
    }), function(data) {

        data = JSON.parse(data);

        if(data.stopSequenceCallRequestId == stopSequenceCallRequestId) {

            var count = data.results.length;
            var waypoints = new Array();

            var firstObj = null;
            var bounds = new google.maps.LatLngBounds();
            $.each(data.results, function(k, v) {

                var coordsObj = {
                    lat: function() {
                        return v["coords"]["lat"];
                    },
                    lng: function() {
                        return v["coords"]["lng"];
                    }
                };
                var obj = {
                    coords: coordsObj,
                    stopCode:  v.stopCode,
                    stopName: v.stopName,
                    stopDesc: v.stopDesc,
                    stopLat: parseFloat(v.stopLat),
                    stopLon: parseFloat(v.stopLon)
                };
                waypoints.push(obj);

                if(count == data.results.length) {
                    firstObj = {
                        coords: coordsObj,
                        stopCode:  v.stopCode,
                        stopName: v.stopName,
                        stopDesc: v.stopDesc,
                        stopLat: parseFloat(v.stopLat),
                        stopLon: parseFloat(v.stopLon)
                    };
                }

                bounds.extend(new google.maps.LatLng(obj.stopLat, obj.stopLon));

                if(!--count) {

                    if(drawMarkers) {
                        stopMarkers = [];
                        stopMarkerIndexes = [];
                        $.each(waypoints, function(k, v) {
                            //setMarker(k, waypoints);

                            //console.log(v);

                            var marker = new google.maps.Marker({
                                map: map,
                                draggable: false,
                                icon: "/images/fa-dot-circle-o.png",
                                position: {lat: parseFloat(v.stopLat), lng: parseFloat(v.stopLon)},
                                id: v.stopCode,
                                title: v.stopDesc
                            });

                            /**
                             * FIRE EVENT: click su fermata
                             */
                            google.maps.event.addListener(marker, 'click', function () {
                                onMarkerClick(this);
                            });

                            stopMarkers[k] = marker;
                            stopMarkerIndexes[marker.id] = k;
                        });
                    }

                    if(routeId == "901") {
                        waypoints.push(firstObj);
                    }

                    if(drawStartAndEnd) {

                        /**
                         * stampa inizio e fine
                         */

                        new google.maps.Marker({
                            map: map,
                            draggable: false,
                            position: {
                                lat: waypoints[0].stopLat,
                                lng: waypoints[0].stopLon
                            },
                            icon: {
                                path: fontawesome.markers.CIRCLE,
                                    scale: 0.1,
                                    strokeWeight: 1.5,
                                    strokeColor: 'black',
                                    strokeOpacity: 1,
                                    fillColor: '#ffffff',
                                    fillOpacity: 0.7
                            }
                        });

                        new google.maps.Marker({
                            map: map,
                            draggable: false,
                            position: {
                                lat: waypoints[waypoints.length - 1].stopLat,
                                lng: waypoints[waypoints.length - 1].stopLon
                            }
                        });
                    }

                    /* pulisce le precedenti polyline disegnate */
                    if(typeof polylinesDrawed[polylinesDrawed.length - 1] != "undefined") {
                        $.each(polylinesDrawed[polylinesDrawed.length - 1], function(k,v) {
                            v.setMap(null);
                        });
                    }
//                            if(typeof polylinesDrawed[polylinesDrawed.length - 1] != "undefined") {
//                                $.each(polylinesDrawed[polylinesDrawed.length - 1]["stops"], function(k,v) {
//                                    v.setMap(null);
//                                });
//                            }

                    if(typeof routesPolylines[routeId] != "undefined") {
                        // console.log('routesPolylines', routesPolylines[routeId]);
                        polylinesDrawed[polylinesDrawed.length] = [
                            new google.maps.Polyline({
                                strokeColor: "#"+routeColor,
                                strokeOpacity: 1.0,
                                strokeWeight: 4,
                                map: map,
                                path: routesPolylines[routeId]
                            })
                        ];
                    } else {
                        // console.log('drawWaypointPolyline');
                        drawWaypointPolyline(map, waypoints, "#"+routeColor, 0);
                    }

                    //$("#stop-search").prop("disabled", true);

                    if(!resetMapSetted) {

                        resetMapSetted = true;

                        setTimeout(function() {
                            var cnt = map.getCenter();
                            cnt.e+=0.000001;
                            map.panTo(cnt);
                            cnt.e-=0.000001;
                            map.panTo(cnt);

                            // Create the DIV to hold the control and call the CenterControl()
                            // constructor passing in this DIV.
                            var resetMapDiv = document.createElement('div');
                            var resetMap = new ResetMap(resetMapDiv, map);

                            resetMapDiv.index = 10;
                            resetMapDiv.classList.add("button-reset-map");
                            map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(resetMapDiv);

                        }, 200);
                    }

                    /* SET BOUNDS */
                    map.fitBounds(bounds);

                    blockStopDeletingForRoutePresence = true;

                    $("#map-overlay-loader").hide();
                }
            });

            if(data.results.length == 0) {
                if(typeof polylinesDrawed[polylinesDrawed.length - 1] != "undefined") {
                    $.each(polylinesDrawed[polylinesDrawed.length - 1], function(k,v) {
                        v.setMap(null);
                    });
                }
//                        if(typeof polylinesDrawed[polylinesDrawed.length - 1] != "undefined") {
//                            $.each(polylinesDrawed[polylinesDrawed.length - 1]["stops"], function(k,v) {
//                                v.setMap(null);
//                            });
//                        }
                $('#modal-route-alert').find("#modal-route-alert-route-code").text(routeShortName);
                $('#modal-route-alert').modal('show');
            }
        }
    });
}

function onMarkerClick(marker) {

    $("#map-overlay-loader").show();

    //map = maps[0];
    if(map.getZoom() < 14) {
        map.setZoom(14);
    }
    map.setCenter(marker.position);

    selectedStopCode = marker.id;
    $('#stop').val(marker.id);
    $('#stop-search').val(marker.id + " - " + marker.title);
    $("#selected-stop").html(marker.title);
    $("#selected-stop-wrapper").show();
    $("#bus-stop-tab-click").trigger("click");

    marker.setIcon("/images/fa-map-marker.png");
    if(previousMarkers.length > 0 && typeof previousMarkers[previousMarkers.length - 1] != "undefined") {
        previousMarkers[previousMarkers.length - 1].setIcon("/images/fa-dot-circle-o.png");
    }
    previousMarkers.push(marker);

    var count = stopMarkers.length;
    if(count == 0) {
        $("#map-overlay-loader").hide();
    }

    /* richiede le corse in arrivo */
    requestIncomingTrips();
}
